(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shade-match-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href="#shade-match"]');
    if (!link) return;

    event.preventDefault();

    if (window.Shopify?.designMode) return;

    const dialog = document.getElementById('shade-match-dialog');
    if (!(dialog instanceof HTMLElement) || typeof (/** @type {*} */ (dialog).showDialog) !== 'function') return;

    const iframe = dialog.querySelector('.shade-match-modal__iframe');
    if (iframe instanceof HTMLIFrameElement && !iframe.src) {
      iframe.src = 'https://aspilon-shadematch.com';
    }

    /** @type {*} */ (dialog).showDialog();
  });
  } catch(e) { console.error(e); }
})();

})();
